import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { accountVerify } from '../../store/actions/users';

import { Loader } from '../../utils/tools';

const AccountVerify = () => {
    const dispatch = useDispatch();
    // for token in server url like parameter
    const [search, setSearch] = useSearchParams();
    const navigate = useNavigate();
    const token = search.get('t');

    useEffect(()=> {
        if(token) {
            dispatch(accountVerify(token))
            .unwrap()
            .then(()=> {
                navigate('/account/verified');
            })
            .catch((err)=> {
                const expired = err?.status === 410 || err?.statusCode === 410;
                navigate('/account/not-verified', { state: { expired } });
            });
        } else {
            navigate('/');
        }
    },[dispatch, navigate]);

    return(
        <>
            <Loader />
        </>
    )
}

export default AccountVerify;
